import React, { useState, useEffect } from 'react';
import './App.css';
import MenuBar from './components/MenuBar';
import FilterSortBar from './components/FilterSortBar';
import ContentArea from './components/ContentArea';
import NavBar from './components/NavBar';
import { fetchWifiData } from './data/getdata';

const App = () => {
  // 状态：存储从 API 获取的 Wi-Fi 数据
  const [data, setData] = useState([]);
  
  // 状态：存储当前选中的选项
  const [selectedOption, setSelectedOption] = useState(null);

  // 从 API 获取 Wi-Fi 数据
  const fetchData = async () => {
    try {
      const wifiData = await fetchWifiData();
      setData(wifiData);
      setSelectedOption(wifiData[0]); // 设置默认选项为第一个
    } catch (error) {
      console.error('Error fetching Wi-Fi data:', error);
    }
  };

  // 处理菜单栏选项选择事件
  const handleMenuItemSelect = (menuItem) => {
    setSelectedOption(menuItem);
  };

  return (
    <div className="app">
      {/* 菜单栏组件，用于选择操作 */}
      <MenuBar onMenuItemSelect={handleMenuItemSelect} />

      {/* 内容区域组件，根据选项显示相应内容 */}
      <ContentArea selectedOption={selectedOption} />

      {/* 导航栏组件 */}
      <NavBar />
    </div>
  );
};




export default App;
